<template>
  <el-breadcrumb class="app-breadcrumb" :separator-icon="ArrowRight">
    <el-breadcrumb-item v-for="item in items" :key="item.path" :to="item.to">
      {{ translateRouteTitle(item) }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script setup>
import { ArrowRight } from '@element-plus/icons-vue'
import { translateRouteTitle } from '@/locales/route'
import { usePageBreadcrumb } from '@/composables/usePageBreadcrumb'
const { items } = usePageBreadcrumb()
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  font-size: 14px;
  line-height: 22px;
  :deep(.el-breadcrumb__inner) {
    color: var(--sb-text-secondary);
    font-weight: 400;
  }
  :deep(.el-breadcrumb__inner.is-link:hover) {
    color: var(--sb-color-primary-text);
    text-decoration: underline;
  }
  :deep(.el-breadcrumb__inner.is-link:focus-visible) {
    outline: 2px solid var(--sb-color-primary-text);
    outline-offset: 2px;
  }
  :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
    color: var(--sb-text-title);
  }
  :deep(.el-breadcrumb__separator) {
    margin-inline: 8px;
    color: var(--sb-text-muted);
  }
}
</style>
